var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarginhomepageAboutBoardDsu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 335.28 418.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        opacity: .16;\n      }\n\n      .cls-3 {\n        fill: #e6e7eb;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.69,0h186.33c1.32,0,2.39,4.9,2.39,10.94v396.57c0,6.04-1.07,10.94-2.39,10.94h-186.33c-1.32,0-2.39-4.9-2.39-10.94V10.94c0-6.04,1.07-10.94,2.39-10.94Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deco"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9720",
    "data-name": "Group 9720",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27730-2",
    "data-name": "Path 27730-2",
    className: "cls-3",
    d: "M276.78,346.01c45.87-46.66,66.56-112.49,55.63-177-5.18-27.56-15.92-53.78-31.59-77.05C238.69,1.22,114.76-21.98,24.02,40.15c-4.87,3.33-9.58,6.88-14.13,10.63-8.91,4.55-12.45,15.47-7.9,24.38,4.55,8.91,15.47,12.45,24.38,7.9,2.4-1.22,4.49-2.97,6.13-5.1,70.59-56.45,173.57-44.98,230.02,25.61,32.06,40.09,43.45,92.89,30.77,142.63-2.95,13.36-7.86,26.21-14.58,38.13-45.03,79.35-145.87,107.18-225.22,62.15-7.52-4.27-14.7-9.12-21.46-14.52-6.95-6.5-17.85-6.14-24.35.81-.05.05-.09.1-.13.15h0c-6.8,7.35-6.35,18.83,1,25.63.25.23.5.45.76.67,79.18,64.59,194.51,58.9,267.47-13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27731-2",
    "data-name": "Path 27731-2",
    className: "cls-3",
    d: "M190.01,204.65c-.07-30.04-24.49-54.34-54.53-54.27-30.04.07-54.34,24.49-54.27,54.53.07,29.95,24.35,54.21,54.3,54.27,29.92.18,54.32-23.92,54.5-53.83,0-.23,0-.47,0-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27732-2",
    "data-name": "Path 27732-2",
    className: "cls-3",
    d: "M228.84,290.76c44.06-47.9,45-121.22,2.18-169.91s-115.59-57.05-168.64-19.36c-8.18,5.8-10.12,17.14-4.32,25.32.47.67.99,1.3,1.54,1.89v.91c6.2,5.85,15.63,6.59,22.66,1.77,36.67-26.68,87.42-22.13,118.74,10.66,32.43,35.46,32.32,89.84-.23,125.19-31.24,32.89-81.98,37.64-118.78,11.11-7.54-4.69-17.32-3.54-23.58,2.76-6.95,6.5-7.31,17.4-.81,24.35,1.03,1.1,2.2,2.06,3.48,2.86,52.12,37.51,124.2,29.97,167.75-17.55h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginhomepageAboutBoardDsu);
export default __webpack_public_path__ + "static/media/margin homepage _ About Board DSU_.5e8bbbe7bb8633ff5f14b0ac52f74b17.svg";
export { ForwardRef as ReactComponent };